module.exports = __webpack_public_path__ + "img/bg4.a5e1a3d3.jpg";